module.exports = __webpack_public_path__ + "static/media/AutoCAD Revit LT Suite.a68b3222.png";